import React from "react";
import { compose } from "@reduxjs/toolkit";
import withLoadData from "./withLoadData";
import { Button, Modal } from "react-bootstrap";
import classes from "./requiredPdfForVirtualFieldAlertModal.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

const RequiredPdfForVirtualFieldAlertModal = ({
  isOpen,
  handleClose,
  handleUploadPdf,
}) => {
  const handleUploadClick = () => {
    handleUploadPdf();
    handleClose();
  };

  return (
    <div>
      <Modal
        style={{ overlay: { zIndex: 999 }, opacity: 1 }}
        animation={false}
        show={isOpen}
        onHide={handleClose}
        size="lg"
        contentClassName={classes.ModalConTent}
        centered={true}
      >
        <Modal.Body className={classes.Body}>
          <div className={classes.AlertContent}>
            <FontAwesomeIcon
              className={classes.AlertIcon}
              icon={faExclamationCircle}
            />
            <span>
              Please load PDF file to select a virtual cell from the virtual
              grid
            </span>
          </div>
          <div className={classes.Footer}>
            <Button variant="success" onClick={handleUploadClick}>
              Upload PDF
            </Button>
            <Button
              variant="secondary"
              className={classes.CancelButton}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default compose(withLoadData)(RequiredPdfForVirtualFieldAlertModal);
